























































































import StaticContainer from './StaticContainer.vue';

export default {
  components: {
    StaticContainer,
  },
};
